import React, { useState } from "react";
import { CampaignViewDetailsViewFullInfoProps } from "./campaign-view-details-view-full-info.props";
import "./campaign-view-details-view-full-info.scss";
import { formatDate, formatDateTime } from "../../../../../../utils/utils";
import { useLogin } from "../../../../../../common/hooks/useUser";
import { useMediaQuery } from "@mui/material";
const LeadViewDetailsViewFullInfo: React.FC<
  CampaignViewDetailsViewFullInfoProps
> = (props: any) => {
  const {
    campaignDetails,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    permissions,
  } = props;
  const [isViewOpen, setIsViewOpen] = useState<boolean>(true);
  const handleEditOpen = () => setViewFullInfoOpen(!viewFullInfoOpen);
  const { tenantDetails } = useLogin();

  const checkIsDisableEdit = () => {
    return tenantDetails?.tenantType === "Tenant" &&
      campaignDetails?.lead_status === "Closed-Lost"
      ? true
      : false;
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <div className="campaign-list-view-details-view-box-full-info">
      {!isMobile && (
        <div className="campaign-list-view-details-view-box-full-info-header">
          <div>Details</div>
          <div>
            {isViewOpen ? (
              <i
                className="fa fa-angle-down"
                onClick={() => {
                  setIsViewOpen(!isViewOpen);
                }}
              />
            ) : (
              <i
                className="fa fa-angle-up"
                onClick={() => {
                  setIsViewOpen(!isViewOpen);
                }}
              />
            )}
          </div>
        </div>
      )}
      {isViewOpen ? (
        <>
          <div className="campaign-list-view-details-view-box-full-info-header-text-edit">
            <div className="campaign-list-view-details-view-box-full-info-header-text">
              Campaign Information
            </div>
            <div className="campaign-list-view-details-view-box-full-info-header-edit">
              <button
                className="campaign-list-view-edit-section"
                onClick={handleEditOpen}
                disabled={checkIsDisableEdit() || !permissions?.canWrite}
              >
                Edit
              </button>
            </div>
          </div>
          <div className="campaign-list-view-details-view-box-full-info-data">
            <div className="campaign-list-view-details-view-box-full-info-data-section">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Campaign Owner
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.campaignOwner?.first_name || ""}{" "}
                  {campaignDetails?.campaignOwner?.last_name || ""}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Campaign Name
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.name || "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Start Date
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {formatDate(campaignDetails?.start_date) || "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Expected Revenue
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.expected_revenue
                    ? `$ ${campaignDetails.expected_revenue}`
                    : "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Actual Cost
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.actual_cost
                    ? `$ ${campaignDetails.actual_cost}`
                    : "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Modified By
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.modified_by || "-"}
                  <br />
                  {formatDateTime(campaignDetails?.updated_at || "-", true)}
                </div>
              </div>
            </div>
            <div className="campaign-list-view-details-view-box-full-info-data-section">
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Type
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.type || "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Status
                </div>
                {campaignDetails?.status || "-"}
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  End Date
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {formatDate(campaignDetails?.end_date) || "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Budgeted Cost
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.budgeted_cost
                    ? `$ ${campaignDetails.budgeted_cost}`
                    : "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Expected Response
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.expected_response || "-"}
                </div>
              </div>
              <div className="campaign-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="campaign-list-view-details-view-box-full-info-data-section-main">
                  Created By
                </div>
                <div className="campaign-list-view-details-view-box-full-info-data-section-sub">
                  {campaignDetails?.created_by || "-"}
                  <br />
                  {formatDateTime(campaignDetails?.created_at || "-", true)}
                </div>
              </div>
            </div>
          </div>
          <div className="campaign-list-view-details-view-box-full-info-header-text">
            Description
          </div>
          <div className="campaign-list-view-details-view-box-full-info-description-box description-box-container">
            {campaignDetails?.description || "-"}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default LeadViewDetailsViewFullInfo;
